import styled from 'styled-components';
import { GraphEditorTopBar } from './GraphEditorTopBar';

export const Container = styled.div`
    width: 100%;
    height: 100vh;
    max-width: 100%;
    max-height: 100vh;
    display: grid;
    grid-template-rows: 54px 1fr;
    grid-template-areas:
        'topbar'
        'main';
`;

export const StyledTopBar = styled(GraphEditorTopBar)`
    grid-area: topbar;
`;

export const MainSection = styled.div`
    grid-area: main;
    position: relative;
    overflow: hidden;
`;
